<rma-split-marketing-layout *transloco="let t; read: 'searchprofile'">
  <ng-container content>
    <rma-focused-layout-header [title]="t('welcome')" [subtitle]="t('we-integrated-with-mls')" />

    <rma-search-auto-complete
      class="relative"
      selectedSearchType="Profiles"
      [autoFocus]="true"
      [showCreateProfile]="true"
      [results]="searchResults$ | async"
      [disabled]="(loading$ | async) ?? false"
      [placeholder]="t('search-placeholder')"
      [rmaLoadingIndicator]="loading$ | async"
      [initalValue]="initialValue"
      (viewedAll)="onViewedAll()"
      (update)="updateSearchTerm($event)"
      (selected)="onSelectedResult($event)" />

    @if (alreadyClaimed$ | async) {
      <p class="bg-blue-10 text-blue-90 mt-4 rounded-sm px-4 py-2">
        {{ t('claimedProfileLoginPrompt') }}
        <a routerLink="/profile/login" queryParamsHandling="preserve">
          {{ t('claimedProfileLoginLinkText') }}
        </a>
      </p>
    } @else {
      <p class="steel-100 my-4">
        {{ t('already-have-a-profile') }}
        <a routerLink="/profile/login" queryParamsHandling="preserve"> {{ t('login') }}</a>
      </p>
    }
  </ng-container>

  <ng-container marketing>
    <div class="flex vh-with-header flex-col">
      <img class="self-end" [src]="'/profile-search/claim-img-top.png' | staticImageUrl" alt="" />

      <div class="flex grow justify-center self-center">
        <img class="m-auto w-full" [src]="'/profile-search/claim-img-headline.png' | staticImageUrl" alt="" />
      </div>

      <div class="self-start justify-self-start">
        <img [src]="'/profile-search/claim-img-bottom.png' | staticImageUrl" alt="" />
      </div>
    </div>
  </ng-container>
</rma-split-marketing-layout>
